import $ from 'jquery';

import AccountIDCommissionFields from 'chairisher/component/form/fieldaccountidcommission';
import Autocomplete from 'chairisher/component/autocomplete';
import ProductUpdateCard from 'chairisher/view/product/update/card';
import ToggleView from 'chairisher/view/toggle';

import { getSpotlightTypesLookupUrl } from 'chairisher/context/product';
import { getAccountLookupUrl, getTreeChoicesByFieldName } from 'chairisher/context/listingflow';

/**
 * View that encapsulates functionality for the "Admin" section of the Product listing flow.
 */
class AdminCard extends ProductUpdateCard {
    constructor() {
        super('#js-admin-fields');
        this.choiceTreeComponentNames = ['spotlight_types'];

        /**
         * Maps a toggle selector to the value that will be passed to the server when toggled
         * @type {Object}
         */
        this.toggleSelectorToStateAttributeMap = null;

        this.initialize();
    }

    /**
     * Updates the current values and visibility of this card's simple fields with a given set of data.
     *
     * @param {Object} data The data to update the fields with
     */
    updateFieldsFromDataObject(data) {
        super.updateFieldsFromDataObject(data);
        const accountData = data.account;
        if (accountData) {
            this.$cardFieldsEl.find('[name=account]').val(accountData.value);

            if (accountData.errors) {
                this.updateFieldErrors('account', accountData.errors);
                this.hasErrors = true;
            }
            $(this.cardSelector).find('.js-section-error').toggleClass('hidden', !this.hasErrors);

            const accountAutocomplete = this.fieldNameToAutocomplete.account;
            accountAutocomplete.setQueryText(accountData.display);

            if (accountData.is_readonly) {
                accountAutocomplete.disable();
            } else {
                accountAutocomplete.enable();
            }
        }
    }

    /**
     * @inheritdoc
     * @override
     */
    updateMetaFieldsFromDataObject(metaData) {
        if (metaData.account_groups_display) {
            this.$cardFieldsEl.find('.js-additional-field-info').text(metaData.account_groups_display);
        }
    }

    /**
     * Binds actions to the various elements that comprise the Card
     */
    bind() {
        super.bind();

        //
        // Account
        //

        const $queryEl = $('#id_account_search');

        const accountAutocomplete = new Autocomplete({
            $queryEl,
            dataDisplayKey: 'email',
            dataObject: {
                limit: 20,
            },
            dataEndpoint: getAccountLookupUrl(),
            isMultiSelect: false,
        });

        $queryEl.on('autocomplete:selected', (_, item) => {
            const changeData = {};
            changeData.account = item.id;

            this.triggerChange(changeData);
        });

        this.fieldNameToAutocomplete.account = accountAutocomplete;

        //
        // Spotlight Types
        //

        this.bindChoiceTreeAutocomplete({
            areOnlyLeafNodesSelectable: true,
            dataDisplayKey: 'display',
            dataEndpoint: getSpotlightTypesLookupUrl(),
            treeChoices: getTreeChoicesByFieldName('spotlight_types'),
            $queryEl: this.$cardFieldsEl.find('[name="spotlight_types"]'),
        });

        //
        // Staff Actions
        //

        $('.js-staff-actions').on('click', '.js-btn-toggle', (e) => {
            e.preventDefault();
            this.triggerChange({
                action: this.toggleSelectorToStateAttributeMap[$(e.currentTarget).data('value-selector')],
            });
        });

        //
        // Account ID Commission Actions
        //
        const commissionCardContainer = this.$cardFieldsEl.find('.js-account-id-commission-rows');
        const commissionCardRow = this.$cardFieldsEl.find('.js-account-id-commission-row');
        const commissionCardAddRow = this.$cardFieldsEl.find('.js-add-account-id-commission-btn');

        const commissionDetails = this.getProductObject().commission_details.value;

        this.accountIDCommissionFields = new AccountIDCommissionFields({
            $containerEl: commissionCardContainer,
            $rowEl: commissionCardRow,
            $addRowEl: commissionCardAddRow,
            commissionDetailsMap: commissionDetails,
        });

        $('.js-account-id-commission-rows')
            .on('autocomplete:selected', '.js-account-id-commission-row', () => {
                const commissionDetailsMap = this.accountIDCommissionFields.getValue();
                this.triggerChange(commissionDetailsMap);
            })
            .on('change', '.js-commission-is-pct', () => {
                const commissionDetailsMap = this.accountIDCommissionFields.getValue();
                this.triggerChange(commissionDetailsMap);
            })
            .on('change', '.js-commission-value', () => {
                const commissionDetailsMap = this.accountIDCommissionFields.getValue();
                this.triggerChange(commissionDetailsMap);
            })
            .on('click', '.js-remove-account-id-commission-row-btn', () => {
                const commissionDetailsMap = this.accountIDCommissionFields.getValue(); // Update values on data removal
                this.triggerChange(commissionDetailsMap);
            });
    }

    /**
     * Updates the actions (state transitions) that can be taken by staff members
     * @param {Array} actions
     */
    updateStaffActions(actions) {
        if (!actions) {
            return;
        }

        this.toggleSelectorToStateAttributeMap = {};

        const $fragment = $('<div></div>', {
            class: 'staff-actions',
        });
        const templateHTML = $('#js-switch-template').html();

        $.each(actions, (i, action) => {
            const $html = $(templateHTML);
            const $btnToggle = $html.find('.js-btn-toggle');

            const toggleClass = `js-staff-action-${i}`;
            const toggleSelector = `.${toggleClass}`;

            $btnToggle.attr({
                'data-active-text': action.display,
                'data-inactive-text': action.display,
                'data-value-selector': toggleSelector,
            });
            $btnToggle.addClass([toggleClass, 'btn-toggle-success'].join(' '));
            $html.find('.js-toggle-text').text(action.display);

            const toggleView = new ToggleView({
                $toggleEl: $btnToggle,
            });
            toggleView.toggle(action.value);
            toggleView.setDisabled(!!action.is_readonly);

            $fragment.append($html);
            this.toggleSelectorToStateAttributeMap[toggleSelector] = action.action_value;
        });

        $('.js-staff-actions').html($fragment);
    }

    /**
     * Populates the list of simple field names
     */
    populateSimpleFieldNames() {
        this.simpleFieldNames = $.makeArray(
            $(this.fieldNames.concat([])).not([
                'account_search',
                'spotlight_types',
                'account_email',
                'is_account_id_commission_pct',
                'account_id_commission_value',
            ]),
        );
    }
}

export default AdminCard;
